<div (click)="handleClick($event)" [class.cursor-pointer]="clickable()">
  @if (show()) {
    <div class="flex border-2 border-solid border-[#A5A6F6] rounded-[15px] overflow-hidden">
      <div class="bg-[#5D5FEF] px-[8px] py-[1px] text-white text-[12px] font-medium leading-[20px] flex items-center justify-center">
        {{ label() }} {{ userIndex() | number: '1.0-2' }}
      </div>
      <div class="flex items-center justify-center bg-white flex-1 text-[#5D5FEF] font-semibold text-[12px] leading-[20px] px-[4px]">
        +{{ userIndexDiff() | number: '1.0-2' }}
      </div>
    </div>
  } @else {
    @if (userIndex() !== null) {
      <div class="flex border-2 border-solid border-[#A5A6F6] rounded-[15px] overflow-hidden">
        <div class="bg-[#5D5FEF] px-[8px] py-[1px] text-white text-[12px] font-medium leading-[20px] flex items-center justify-center">
          {{ label() }} {{ userIndex() | number: '1.0-2' }}
        </div>
        <div class="flex items-center justify-center bg-white flex-1 text-[#5D5FEF] font-semibold text-[12px] leading-[20px] px-[4px]">
          +{{ userIndexDiff() | number: '1.0-2' }}
        </div>
      </div>
    }
  }
</div>
